import { classNames, Component, h, signal, tag } from "omi";

import { Timeout } from "@/types/timers";
import { tailwind } from "@/tailwind";

type Props = {
  content?: string;
  heading: string;
  trigger?: "hover" | "click";
};

@tag("social-tooltip")
export class SocialTooltip extends Component<Props> {
  static css = [tailwind];

  private isVisible = signal(false);
  private timeoutId: Timeout | null = null;

  uninstall(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  private handleClick = () => {
    this.isVisible.value = !this.isVisible.value;
    this.timeoutId = setTimeout(() => {
      this.isVisible.value = false;
    }, 2000);
  };

  render({ heading, content, trigger = "hover" }: Props) {
    return (
      <div className="relative group" onClick={this.handleClick}>
        <slot />
        <div
          className={classNames(
            "absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 bg-[#0C111D] text-white shadow-lg rounded-lg pointer-events-none text-sm transition-all ease-in-out font-semibold duration-600 max-w-80 w-max",
            { "group-hover:opacity-100 group-hover:scale-100": trigger === "hover" },
            { "opacity-100 scale-100": this.isVisible.value },
            { "opacity-0 scale-75": !this.isVisible.value },
            { "pointer-events-none": trigger === "hover" },
            { "cursor-pointer": trigger === "click" },
          )}
          style={{ transitionTimingFunction: "cubic-bezier(.54, 1.5, .38, 1.11)" }}
        >
          <h4 className="mb-0.5 text-sm font-semibold text-white whitespace-nowrap">{heading}</h4>
          {content && <p className="text-sm whitespace-normal text-gray-300">{content}</p>}
          <div
            id="tooltip-arrow"
            className="absolute top-full left-1/2 -translate-x-1/2 -mt-px border-[8px] border-transparent border-t-[#0C111D]"
          ></div>
        </div>
      </div>
    );
  }
}
